import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/login";
import Home from "./pages/home";
import Registro from "./pages/registro";
import Ranking from "./pages/ranking";
import Navbar from "./components/navbar";
import PanelAdmin from "./admin/panelAdministrador"
import ProtectedRoute from "./components/ProtectedRoute"; 
import AgregarJugador from "./admin/agregarJugador";
import EditarJugador from "./admin/editarJugador";
import PerfilEditable from "./pages/perfilEditable";
import FormCrearTorneo from "./admin/crearTorneo";
import CrearTorneo from "./admin/crearTorneo";
import InscripcionTorneo from "./pages/inscripcionTorneo";
import ListaTorneos from "./pages/listaTorneos";
import TorneosAdmin from "./admin/TorneosAdmin";
import ParejasTorneoAdmin from "./admin/ParejasTorneoAdmin";
import PerfilTorneosJugados from "./pages/perfiltorneosjugados";


function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registro" element={<Registro />} />
        <Route path="/perfil/:id" element={<PerfilEditable/>} />
        <Route path="/perfil" element={<PerfilEditable />} /> {/* Ruta para el perfil */}
        <Route path="/perfiltorneosjugados/:id" element={<PerfilTorneosJugados />} />
        <Route path="/torneos/:torneoId/inscripcion" element={<InscripcionTorneo />} />
        <Route path="/torneos" element={<ListaTorneos />} />
        <Route path="/ranking" element={<Ranking />} />

        <Route
  path="/admin/panel"
  element={
    <ProtectedRoute rolPermitido="admin">
      <PanelAdmin />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin/agregar-jugador"
  element={
    <ProtectedRoute rolPermitido="admin">
      <AgregarJugador />
    </ProtectedRoute>
  }
/>
<Route path="/admin/editar-jugador/:id" element={<EditarJugador />} />

<Route path="/admin/torneos" element={<FormCrearTorneo />} />
<Route path="/admin/crear-torneo" element={<CrearTorneo />} />
<Route path="/admin/lista-torneos" element={<TorneosAdmin />} />
<Route path="/admin/torneos/:torneoId/parejas" element={<ParejasTorneoAdmin />} />
        

</Routes>
</BrowserRouter>
  );
}

export default App;

